export default __webpack_public_path__ + "static/JarDwellers-20e0577fcc7d425416466dead9fed389.png";